import { render, staticRenderFns } from "./onKlnt.vue?vue&type=template&id=603ed2ea&scoped=true"
import script from "./onKlnt.vue?vue&type=script&lang=js"
export * from "./onKlnt.vue?vue&type=script&lang=js"
import style0 from "./onKlnt.vue?vue&type=style&index=0&id=603ed2ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "603ed2ea",
  null
  
)

export default component.exports